import {Directive, ElementRef, Renderer} from "@angular/core";

@Directive({
  selector : 'nbinput-focus'
})
export class NbinputFocusDirective {
  constructor(public renderer: Renderer, public elementRef: ElementRef) {}

  ngOnInit() {
    this.renderer.invokeElementMethod(
      this.elementRef.nativeElement, 'focus', []);
  }
}
